const CustomCode: React.FunctionComponent = function () {
  return <div>CustomCode</div>;
};

export default CustomCode;
